import React,{Component} from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from "react-redux"
import { bindActionCreators } from "redux";

import * as dashboardParserActions from "../../actions/dashboardParserActions";
import * as profileHelpers from "../../helpers/profileHelpers"

import Parser from './Parser'
import Offers from './Offers'
import Summary from './Summary'
import Errors from './Errors'

class Dashboard extends Component{
    render(){
        let {profile} = this.props;

        if(!profileHelpers.isAdmin(profile)){
            return null
        }

        return(
            <Switch>
                <Route path="/dashboard/parser" component={Parser} />
                <Route path="/dashboard/offers/:id" component={Offers} />
                <Route path="/dashboard/summary" component={Summary} />
                <Route path="/dashboard/errors/:id" component={Errors} />
            </Switch>
        )
    }
}


function mapStateToProps(state) {
    return {
        profile: state.profile
    }
}

export default connect(mapStateToProps)(Dashboard);


// WEBPACK FOOTER //
// ./src/components/Dashboard/index.jsx